function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import Vue from 'vue';
import { VTextField } from 'vuetify/lib';
import FormMixin from '../form.mixin';

var Input = /*#__PURE__*/function () {
  function Input() {
    _classCallCheck(this, Input);
  }

  _createClass(Input, null, [{
    key: "register",
    value: function register() {
      Vue.component('roche-input', {
        template: "<v-text-field\n        v-bind=\"bind\"\n        v-on=\"$listeners\"\n        @input=\"$emit('input', $event)\"\n        :rules=\"rules\"\n        persistent-placeholder>\n        <slot/>\n        </v-text-field>",
        mixins: [FormMixin],
        components: {
          VTextField: VTextField
        },
        created: function created() {
          var _this = this;

          this.$nextTick(function () {
            if (_this.$slots["default"]) {
              _this.$emit('input', _this.$slots["default"][0].text);
            }
          });
        }
      });
    }
  }]);

  return Input;
}();

export default Input;